import type { BlockPlugin } from "../types";
import { codeBlock } from "./code";
import { fillBlankBlock } from "./fill-blank";
import { flashcardBlock } from "./flashcard";
import { listenTypeBlock } from "./listen-type";
import { matchBlock } from "./match";
import { quizBlock } from "./quiz";

export * from "./quiz";
export * from "./flashcard";
export * from "./fill-blank";
export * from "./match";
export * from "./code";
export * from "./listen-type";

/** Base block types shipped with Aula. */
export const baseBlocks: readonly BlockPlugin[] = [
  quizBlock,
  flashcardBlock,
  fillBlankBlock,
  matchBlock,
  codeBlock,
  listenTypeBlock,
] as BlockPlugin[];
